module.exports = __webpack_public_path__ + "img/camión.fb6d3720.png";